export default function removeParamsFormHash(filter, value) {
  const facets = {};
  let query = "";
  filter.split("&").forEach((item) => {
    const [cat, val] = item.split("=");
    if (!facets[cat]) {
      facets[cat] = [];
    }
    if (val === value) return;
    (facets[cat]).push(val);
  });

  Object.keys(facets).forEach((item) => {
    facets[item].forEach((param) => {
      query += `&${item}=${param}`;
    });
  });
  return query.replace("&", "");
}
